// Read-only conversation API for widget.
// All DB writes are handled by the agent (voice-receptionist).
function getApiBaseUrl() {
    if (typeof window !== 'undefined') {
        const scriptTag = document.querySelector('script[data-lk-sandbox-id]');
        if (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.src) {
            try {
                return new URL(scriptTag.src).origin;
            }
            catch (_a) {
                // Fall back
            }
        }
    }
    return typeof window !== 'undefined' ? window.location.origin : '';
}
function getDomain() {
    if (typeof window === 'undefined')
        return 'unknown';
    return window.location.hostname;
}
export async function findConversation(widgetId, visitorId, visitorEmail) {
    const baseUrl = getApiBaseUrl();
    const res = await fetch(`${baseUrl}/api/conversations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            widgetId,
            domain: getDomain(),
            visitorId,
            visitorEmail,
        }),
    });
    if (!res.ok) {
        throw new Error(`Conversation API error: ${res.status}`);
    }
    return res.json();
}
